export default __webpack_public_path__ + "static/media/face_react_portfolio.511eb3c8.jpeg";